import { LoiSigningMode } from '../../loi-preparation/models/loi-co-owners-preview.model';

export enum LoiSignerRole {
    PrimaryOwner = 0,
    FellowOwner = 1,
    CoOwner = 2,
}

export interface LoiSignerStatus {
    name: string;
    role: LoiSignerRole;
    mode: LoiSigningMode;
    isSigned: boolean;
}

export interface LoiSigningStatus {
    documentDetailsId: string;
    isPrepared: boolean;
    isPrimaryOwnerSigned: boolean;
    isCompleted: boolean;
    currentUserMode: LoiSigningMode | null;
    isCurrentUserSigned: boolean;
    canCurrentUserSign: boolean;
    isCurrentUserSigningLinkSent: boolean;
    signers: LoiSignerStatus[];
}
